<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de permissão por papel">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/administracao/relatorio-permissao-papel/List'

export default {
    components: {List},
}
</script>